import React from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';

interface Props {}

const J: React.FC<Props> = ({}) => {
    const { t } = useLang('theProduct.J');

    return (
        <section
            id="rapid-mag-J"
            className={`rapid-mag-J ${css.section} GtmModuleData-section`}
            data-section-id={'rapid-mag-J'}
            data-section-title={t('title')}
        >
            <div className="info">
                <p className="title">{t('title')}</p>
                <p className="subtitle">{t('subtitle')}</p>
                <p className="desc">{t('desc')}</p>
                <div className="img">
                    <EcoImg
                        pc="https://websiteoss.ecoflow.com/figma-uploads/1762515004911-r95tet-compressed-Frame%201612707984.jpg"
                        pad="https://websiteoss.ecoflow.com/figma-uploads/1762515004911-r95tet-compressed-Frame%201612707984.jpg"
                        h5="https://websiteoss.ecoflow.com/figma-uploads/1762515022214-mkwloa-compressed-Frame%201612707986.jpg"
                    />
                </div>
            </div>
        </section>
    );
};
export default J;
